import cn from "classnames";
import { Skeleton } from "@crehana/ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AcademyEnrollmentSkeleton = function AcademyEnrollmentSkeleton(_ref) {
  var isDark = _ref.isDark;
  var innerBackgroundColor = isDark ? 'bg-base-lighter-dark-mode' : 'bg-gray-main';
  return /*#__PURE__*/_jsx(Skeleton, {
    className: "p-16 rounded-5",
    isDark: isDark,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col sm:flex-row",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex w-full",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          className: cn('w-32 h-32 mr-16 sm:w-64 sm:h-64 rounded-5 flex-shrink-0', innerBackgroundColor)
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center w-full sm:block",
          children: [/*#__PURE__*/_jsx(Skeleton, {
            className: cn('w-3/4 h-20 sm:h-24 rounded-5', innerBackgroundColor)
          }), /*#__PURE__*/_jsx(Skeleton, {
            className: cn('w-64 h-16 mt-12 rounded-5 hidden sm:block', innerBackgroundColor)
          })]
        })]
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: cn('w-64 h-16 mt-12 rounded-5 sm:hidden', innerBackgroundColor)
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: cn('w-full h-40 mt-12 rounded-5 sm:w-212', innerBackgroundColor)
      })]
    })
  });
};
export default AcademyEnrollmentSkeleton;